import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatPagination = createCustomElementWrapper('kat-pagination', 'KatPagination', {
    'itemsPerPage': 'items-per-page',
    'itemsPerPageOptions': 'items-per-page-options',
    'openEnded': 'open-ended',
    'totalItems': 'total-items',
}, {
    'onChange': 'change',
    'onItemsPerPageChange': 'items-per-page-change',
    'onPageChanged': 'page-changed',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/pagination.js
// module id = 1277
// module chunks = 0